import React, { Component, useState, useEffect } from "react";
import { Box } from "@mui/material";
import { FormControl, FormGroup } from "@mui/material";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Accordion from "react-bootstrap/Accordion";
import AddIcon from "@mui/icons-material/Add";
import settings from "../../helpers/settings";
import EastIcon from "@mui/icons-material/East";
import axios, { all } from "axios";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Icon } from "@iconify/react";
import { IconButton } from "@mui/material";
import { Multiselect } from "multiselect-react-dropdown";
import Select from "react-select";
import Cookies from "js-cookie";
import EditIcon from "@mui/icons-material/Edit";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import Typography from "@mui/material/Typography";
import Autocomplete from "../AutoComplete";
// import AutoComplete from "@mui/material/Autocomplete";
// import TextField from "@mui/material/TextField";
// import debounce from "lodash/debounce";
// import { PDFDocument,StandardFonts,rgb } from 'pdf-lib';
// import React, { useState, useEffect } from 'react'; // Import React and hooks
// import { PDFDocument, rgb, StandardFonts, degrees } from 'pdf-lib';
// import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf';
import PDFGenerator from "./generatePDF";
// import { selectOptions } from "@testing-library/user-event/dist/cjs/utility/selectOptions.js";

// import Docxtemplater from 'docxtemplater';
// import PizZip from 'pizzip';
// import PizZipUtils from 'pizzip/utils/index.js';
// import { saveAs } from 'file-saver';
// import expressionParser from 'docxtemplater/expressions';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
let { KayanURL } = settings;
// const loadFile = async (url, callback) =>{
//   PizZipUtils.getBinaryContent(url, callback);
// }
const unitsMap = {
  "days-supply": "d",
  "vital-sign-weight": "kg",
  "vital-sign-systolic": "mm[Hg]",
  "vital-sign-diastolic": "mm[Hg]",
  "icu-hours": "h",
  "ventilation-hours": "h",
  "vital-sign-height": "cm",
};
class PreAuthorization extends Component {
  constructor(props) {
    super(props);
    this.pdfGeneratorRef = React.createRef();
    this.state = {
      onAdmissionDisabled: false,
      showRow: false,
      purposes: [],
      allDiagnosis: [],
      careTeams: [],
      addCareTeamtotable: false,
      addDiagnosistotable: false,
      procedures: [],
      isPackage: false,
      addProceduretotable: false,
      allDiagnosisSelect: [],
      allCareTeamSelect: [],
      vitalSignSelectArray: [],
      addVitaltotable: false,
      vitalSignsArray: [],
      supportingInfo: [],
      vitalSelect: "",
      vitalValue: "",
      productOrService: {},
      diagnosisCode: {},
      totalPrice: 0,
      // showauthInfo: false,
      diagnosisCodeValue: "",
      procedureCodeValue: "",
      diagnosisType: "",
      diagnosisDesc: "",
      onAdmissionValue: "",
      resetProcedure: false,
      updateDiagnosis: false,
      claimTypeValue: "",
      claimSubTypeValue: "",
      priorityValue: "",
      encounterClassValue: "",
      enconterStatusValue: "",
      prescriberValue: "",
      practitionerValue: "",
      DiagnosisAutoCompleteValue: false,
      isDataFetched: false,
      serviceOptions: [],
      procedureAutoCompleteValue: false,
      codeOptions: [],
      filteredOptions: [],
      attachmentReason: {},
      selectedOptions: [],
      selectOptionsCareTeam: [],
      selectedOptionsDiagnosis: [],
      keyinfo: 0,
      keyDiag: 0,
      keyCare: 0,
      nonStandardCodeOptions: [],
      ///////
      consentFormAttached: false,
      attReason: "",
      errorSizeMessage: "",
      showError: false,
    };
  }

  componentDidMount = async () => {
    this.getAllPatient();
    this.getAllDoctors();
    this.geTUesrInfo();
    this.getDiagnosisList();
    let currentDate = new Date();
    // currentDate.setUTCHours(currentDate.getUTCHours() + 4);
    // let formattedDate = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}
    // -${String(currentDate.getUTCDate()).padStart(2,"0")}T${String(currentDate.getUTCHours()).padStart(2, "0")}:
    // ${String( currentDate.getUTCMinutes()).padStart(2, "0")}`;
    let formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}T${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}`;

    let newIdentifier = Date.now();
    this.setState({
      dateOrdered: formattedDate,
      servicedDate: formattedDate.split("T")[0],
      start: formattedDate.split("T")[0],
      end: formattedDate.split("T")[0],
      encounter: {
        ...this.state.encounter,
        start: formattedDate,
        end: formattedDate,
        identifier: newIdentifier,
      },
      identifier: newIdentifier,
    });

    if (this.props.flag) {
      this.setState({ selectedPatient: this.props.selectedPatient });
    }
  };
  getNonStandardCodesList = async (code) => {
    let { nonStandardCodeOptions } = this.state;
    let priceList = await axios.put(
      KayanURL + "/test/patients/priceList/getNonStandardCodeList",
      {
        apiToken: Cookies.get("id"),
        standardCode: code,
        payerId: this.state.selectedPatient.payer_name

      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        if (data.success) {
          let { priceList } = data;
          if (priceList && priceList.length > 0) {
            priceList.forEach((e) => {
              nonStandardCodeOptions.push(e.nonstandardcode);
            });
          }

          this.setState({ nonStandardCodeOptions: nonStandardCodeOptions });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  getDiagnosisList = async () => {
    let { codeOptions } = this.state;
    try {
      let response = await axios.put(KayanURL + "/test/data/getAllDiagnosis", {
        apiToken: Cookies.get("id"),
      });
      if (response) {
        let { data } = response;
        if (data) {
          if (data.success) {
            let { ICD } = data;
            ICD.forEach((e) => {
              codeOptions.push(e.code + "~" + e.short_description);
            });
            // return codeOptions
            this.setState({ codeOptions: codeOptions, isDataFetched: true });
          } else {
            this.setState({ error: data.error });
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error
    }
  };
  getServiceCode = async (type) => {
    let { serviceOptions } = this.state;
    let response = await axios.put(
      /* KayanURL + */ "https://om.kayan-healthcare.com/test/data/getAllServices/" +
      type,
      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        if (data.success) {
          let { Codes } = data;
          Codes.forEach((e) => {
            serviceOptions.push(e.code + "~" + e.short_description);
          });
          this.setState({ serviceOptions: serviceOptions });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  getPriceListInfo = async () => {
    this.setState({ getPriceListLoading: "true" });
    let priceList = await axios.put(
      KayanURL + "/test/patients/priceList/getPriceListInfo",
      {
        standardCode: this.state.productOrService.code,
        nonStandardCode: this.state.nonstandardCode
          ? this.state.nonstandardCode
          : "",
        payerId: this.state.selectedPatient.payer_name,
        apiToken: Cookies.get("id"),
      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        this.setState({ getPriceListLoading: false });
        if (data.success) {
          let { priceList } = data;

          this.setState({ priceList: priceList });
          if (priceList && priceList.length > 0) {
            this.setState({
              procedure: {
                ...this.state.procedure,
                unitPrice: priceList[0].price,
                factor: priceList[0].factor,
                tax: priceList[0].tax,
                patientShare: priceList[0].patientshare,
              },
              unitPrice: priceList[0].price,
              factor: priceList[0].factor,
              tax: priceList[0].tax,
              patientShare: priceList[0].patientshare,
            });
          }
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  handleDiagnosisSelect = (value) => {
    let { diagnosisCode } = this.state;
    let split = value.split("~");
    let code = split[0];
    let description = split[1];
    diagnosisCode["code"] = code;
    diagnosisCode["text"] = description;
    this.setState({

      DiagnosisAutoCompleteValue: false,
      diagnosisCode
    });
  };
  handleItemCodeSelect = (value) => {
    let { productOrService } = this.state;
    let split = value.split("~");
    let code = split[0];
    let description = split[1];
    productOrService["code"] = code;
    productOrService["display"] = description;
    this.getNonStandardCodesList(code);
    this.setState({
      procedureAutoCompleteValue: false,
      productOrService,
    });
  };
  handleNonStandardCodeSelect = (value) => {
    let { productOrService } = this.state;
    productOrService["payerCode"] = value;
    this.setState({
      nonstandardCode: value,
      noneStandardAutoCompleteValue: false,
    });
  };
  getAllDoctors = async () => {
    let response = await axios.put(
      KayanURL + "/test/doctors/getAllDoctors/",

      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { success } = data;
        if (success) {
          this.setState({ allDoctors: data.doctors });
        }
      }
    }
  };
  geTUesrInfo = async () => {
    let response = await axios.put(
      KayanURL + "/test/users/getUserInfo",

      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { providerDhamaniID } = data;
        this.setState({ providerDhamaniID });
      }
    }
  };
  getAllPatient = async () => {
    let AllPatients = [];
    let { allPatients } = this.state;
    let response = await axios.put(
      KayanURL + "/test/patients/getPatientEligibilityInfo",

      {
        apiToken: Cookies.get("id"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        let { success } = data;
        if (success) {
          let patients = data.eligibilityHistory;
          if (patients && patients.length > 0) {
            for (let i = 0; i < patients.length > 0; i++) {
              if (patients[i].service_date) {
                AllPatients.push(patients[i]);
              }
            }
            this.setState({ allPatients: AllPatients });
          }
        }
      }
    }
  };
  onSelectValue = (e) => {
    this.setState({ selectedPatientID: e.value });
    let allPatients = this.state.allPatients;
    let selectedPatient = allPatients.filter((p) => {
      return p.profile_id == e.value;
    });
    if (selectedPatient && selectedPatient.length > 0) {
      this.setState({
        selectedPatient: selectedPatient[0],
      });
    }
  };
  handleAddSupportingInfo = async (e) => {
    e.preventDefault();
    this.setState({
      category: "",
      valueQuantity: "",
    });
    let { vitalSignJson, supportingInfo, vitalSignSelectArray } = this.state;
    vitalSignJson.unit = unitsMap[vitalSignJson.category];
    vitalSignJson.valueQuantityCode = unitsMap[vitalSignJson.category];

    supportingInfo.push(vitalSignJson);
    if (!vitalSignSelectArray) {
      vitalSignSelectArray = supportingInfo.map((info) => ({
        view: `${info.category} ${info.valueQuantity} ${info.unit}`,
      }));
    } else {
      vitalSignSelectArray.push({
        view: `${vitalSignJson.category} ${vitalSignJson.valueQuantity} ${vitalSignJson.unit}`,
      });
    }

    this.setState({
      addVitaltotable: true,
      vitalSignSelectArray,
      supportingInfo,
    });
  };
  handleDeleteVital = (index) => {
    let { vitalSignJson, supportingInfo, vitalSignSelectArray } = this.state;
    supportingInfo.splice(index, 1);
    vitalSignSelectArray.splice(index, 1);
    this.setState({ supportingInfo });
    if (JSON.stringify(vitalSignJson) == "[]") {
      this.setState({ addVitaltotable: false });
    }
  };
  HandleVitalSignInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      vitalSignJson: { ...this.state.vitalSignJson, [name]: value },
      [name]: value,
    });
  };

  HandleInputTextChange = (e) => {
    let { allDoctors, claimTypeValue } = this.state;
    let name = e.target.name;
    let value = e.target.value;
    if (name == "prescriber") {
      let selectedDoctor = allDoctors.filter((p) => {
        return p.id == value;
      });
      if (selectedDoctor && selectedDoctor.length > 0) {
        this.setState({
          prescriberInfo: {
            code: "MD",
            display: "Medical License number",
            license: selectedDoctor[0].license,
            name: selectedDoctor[0].full_name,
          },
        });
      }
      this.setState({ prescriberValue: value, errorPrescriber: "" });
    }
    this.setState({ [name]: value });
    if (name == "claimType") {
      if (value != "institutional") {
        this.setState({
          claimTypeValue: value,
          errorClaimType: "",
          onAdmissionDisabled: true,
        });
      } else {
        this.setState({
          claimTypeValue: value,
          errorClaimType: "",
          onAdmissionDisabled: false,
        });
      }
    }
    if (name == "claimSubType") {
      this.setState({ claimSubTypeValue: value, errorClaimSubType: "" });
    }
    if (name == "priority") {
      this.setState({ priorityValue: value, errorpriority: "" });
    }
  };
  HandleDiagnosisInputTextChange = (e) => {
    // let { diagnosisCode } = this.state;
    let name = e.target.name;
    let value = e.target.value;
    // if (name == "type") {
    //   this.setState({
    //     diagnosisType: value,
    //     diagnosis: { ...this.state.diagnosis, [name]: value },
    //   });
    // }
    if (name == "type") {
      if (value == "principal" && this.state.diagnosisType == "principal") {
        this.setState({
          errorMessage: "You can only select 'Principal' type once.",
        });
      } else {
        this.setState({
          diagnosisType: value,
          diagnosis: { ...this.state.diagnosis, [name]: value },
          errorMessage: "",
        });
      }
    } else if (name == "onAdmission") {
      this.setState({
        onAdmissionValue: value,
        diagnosis: { ...this.state.diagnosis, [name]: value },
      });
    }
  };
  handleAddDiagnosis = async (e) => {
    e.preventDefault();
    this.setState({
      diagnosisType: "",
      onAdmissionValue: "",
      DiagnosisAutoCompleteValue: true,
    });

    let {
      allDiagnosis,
      diagnosis,
      diagnosisType,
      allDiagnosisSelect,
      diagnosisCode,
      diagnosisSelectedIndex,
      updateDiagnosis,
      claimTypeValue,
      onAdmissionValue,
    } = this.state;
    const hasPrincipalDiagnosis = allDiagnosis.some(
      (diagnosis, index) =>
        diagnosis.type == "principal" &&
        (!updateDiagnosis || index !== diagnosisSelectedIndex)
    );

    if (diagnosisType == "principal" && hasPrincipalDiagnosis) {
      this.setState({
        errorMessage: "You can only have one 'Principal' type diagnosis.",
      });
      return;
    }
    if (claimTypeValue == "institutional" && !onAdmissionValue) {
      this.setState({
        errorMessage:
          "Please select 'On Admission' for institutional claim type.",
      });
      return;
    }

    this.setState({
      diagnosisType: "",
      onAdmissionValue: "",
      DiagnosisAutoCompleteValue: true,
    });
    diagnosis["code"] = diagnosisCode;

    if (updateDiagnosis) {
      allDiagnosis[diagnosisSelectedIndex] = diagnosis;
      this.setState({ updateDiagnosis: false });
    } else {
      allDiagnosis.push(diagnosis);
    }
    if (!allDiagnosisSelect) {
      for (let i = 0; i < allDiagnosis.length; i++) {
        allDiagnosisSelect.push({
          view: allDiagnosis[i].type + " " + allDiagnosis[i].code.code,
        });
      }
    } else {
      allDiagnosisSelect.push({
        view: diagnosis.type + " " + diagnosis.code.code,
      });
    }

    this.setState({
      allDiagnosis,
      allDiagnosisSelect,
      addDiagnosistotable: true,
      diagnosis: {},
      diagnosisCode: {},
    });
  };
  handleDeleteDiagnosis = (index) => {
    let { allDiagnosis, allDiagnosisSelect } = this.state;
    allDiagnosisSelect.splice(index, 1);
    allDiagnosis.splice(index, 1);
    this.setState({ allDiagnosis });
    if (JSON.stringify(allDiagnosis) == "[]") {
      this.setState({ addDiagnosistotable: false });
    }
  };
  handleUpdateDiagnosis = (index) => {
    let { allDiagnosis } = this.state;
    let diagnosisSelected = allDiagnosis[index];
    this.setState({
      updateDiagnosis: true,
      diagnosisSelectedIndex: index,
      diagnosis: diagnosisSelected,
      diagnosisCode: {
        code: diagnosisSelected.code.code,
        text: diagnosisSelected.code.text,
      },
      diagnosisCodeValue:
        diagnosisSelected.code.code + "-" + diagnosisSelected.code.text,
      diagnosisType: diagnosisSelected.type,
      // diagnosisDesc: diagnosisSelected.code.text,
      DiagnosisAutoCompleteValue: false,
      onAdmissionValue: diagnosisSelected.onAdmission
        ? diagnosisSelected.onAdmission
        : "",
    });
  };
  HandleProcedureInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ resetProcedure: false, proceduresError: "" });
    let { productOrService } = this.state;
    if (name == "type") {
      this.getServiceCode(value);
      productOrService["list"] = value;
      this.setState({ [name]: value });
      this.setState({ errorItemType: "", procedureAutoCompleteValue: true });
    } else {
      this.setState({
        procedure: { ...this.state.procedure, [name]: value },
        [name]: value,
      });
    }
    if (name == "unitPrice") {
      this.setState({ errorPrice: "" });
    }
    if (name == "factor") {
      this.setState({ errorFactor: "" });
    }
    if (name == "tax") {
      this.setState({ errorTax: "", errorTaxAmount: "" });
    }
    if (name == "patientShare") {
      this.setState({
        errorPatientShare: "",
        errorPayerpatientShare: "",
        errorRequestedpatientShare: "",
      });
    }
  };
  HandleEncounterInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if (name == "class") {
      this.setState({
        encounter: {
          ...this.state.encounter,
          class: {
            code: value.split("-")[0],
            display: value.split("-")[1],
          },
        },
      });
      this.setState({ encounterClassValue: value, errorClassValue: "" });
    } else {
      this.setState({
        encounter: { ...this.state.encounter, [name]: value },
        [name]: value,
      });
    }
    if (name == "status") {
      this.setState({ enconterStatusValue: value, errorStatusValue: "" });
    }
  };
  handleCheckBoxChange = (e) => {
    if (e.target.name == "package") {
      if (e.target.checked) {
        this.setState({ isPackage: true });
      } else {
        this.setState({ isPackage: false });
      }
    }
  };
  onSelectCareTeams = (selectedList) => {
    let { allCareTeamSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allCareTeamSelect.indexOf(item) + 1);
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        careTeamSequence: Values,
      },
      selectOptionsCareTeam: selectedList
    });

  };
  onRemoveCareTeams = (selectedList, removedItem) => {
    let { allCareTeamSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allCareTeamSelect.indexOf(item) + 1 !=
        allCareTeamSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allCareTeamSelect.indexOf(item) + 1);
      }
    });
    this.setState({
      selectOptionsCareTeam: selectedList
    });
  };
  onSelectDiagnosis = (selectedList) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allDiagnosisSelect.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
      selectedOptionsDiagnosis: selectedList
    });
  };
  onRemoveDiagnosis = (selectedList, removedItem) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allDiagnosisSelect.indexOf(item) + 1 !=
        allDiagnosisSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allDiagnosisSelect.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
      selectedOptionsDiagnosis: selectedList
    });
  };
  handleRestItemsValue = (e) => {
    e.preventDefault();
    let { vitalSignSelectArray, allDiagnosisSelect, allCareTeamSelect } = this.state
    this.setState({
      tax: "",
      code: "",
      description: "",
      patientShare: "",
      unitPrice: "",
      factor: "",
      quantity: "",
      type: "",
      selectedOptions: [],
      selectOptionsCareTeam: [],
      selectedOptionsDiagnosis: [],
      procedureAutoCompleteValue: true,
      noneStandardAutoCompleteValue: true,
      nonstandardCode: "",
    });
    this.setState((prevState) => ({
      vitalSignSelectArray,
      keyinfo: prevState.keyinfo + 1,
      allDiagnosisSelect,
      keyDiag: prevState.keyDiag + 1,
      allCareTeamSelect,
      keyCare: prevState.keyCare + 1
    }));
  };
  handleAddProcedure = async (e) => {
    e.preventDefault();
    let { vitalSignSelectArray, allDiagnosisSelect, allCareTeamSelect } = this.state;
    this.setState({
      errorValidForm: "",
      procedureAutoCompleteValue: true,
      noneStandardAutoCompleteValue: true,
    });
    let formIsValid = true;
    if (!this.state.type) {
      this.setState({ errorItemType: "Type is required!" });
      formIsValid = false;
    }
    if (!this.state.unitPrice) {
      this.setState({ errorPrice: "Price is required!" });
      formIsValid = false;
    }
    if (!this.state.factor) {
      this.setState({ errorFactor: "Factor is required!" });
      formIsValid = false;
    }
    if (!this.state.tax && this.state.tax !== 0) {
      this.setState({
        errorTax: "Tax is required!",
        errorTaxAmount: "Tax or Quantity is required!",
      });
      formIsValid = false;
    }
    if (
      !this.state.unitPrice &&
      !this.state.factor &&
      !this.state.tax &&
      !this.state.quantity
    ) {
      this.setState({ errorNet: "Net is Required!" });
      formIsValid = false;
    } else {
      this.setState({ errorNet: "" });
    }
    // console.log(this.state.patientShare,'patienttttt')
    if (!this.state.patientShare && this.state.patientShare !== 0) {
      this.setState({
        errorPatientShare: "Patient Share is required!",
        errorPayerpatientShare: "Patient Share is required!",
        errorRequestedpatientShare: "Patient Share is required!",
      });
      formIsValid = false;
    }
    if (!formIsValid) {
      this.setState({ errorValidForm: "Please fill out all required fields." });
      return;
    }

    this.setState({
      code: "",
      tax: "",
      patientShare: "",
      unitPrice: "",
      factor: "",
      quantity: "",
      type: "",
      selectedOptions: [],
      selectOptionsCareTeam: [],
      selectedOptionsDiagnosis: [],
      procedureAutoCompleteValue: true,
      noneStandardAutoCompleteValue: true,
      nonstandardCode: "",
    });

    let {
      procedures,
      procedure,
      productOrService,
      totalPrice,
      procedureSelectedIndex,
      updateProcedure,
    } = this.state;

    procedure["productOrService"] = productOrService;
    if (procedure) {
      procedure["servicedDate"] = this.state.servicedDate;
      let Net =
        parseFloat(procedure["unitPrice"]) *
        parseFloat(procedure["quantity"]) *
        parseFloat(procedure["factor"]) +
        parseFloat(procedure["tax"]);
      procedure["productOrService"] = productOrService;
      procedure["isPackage"] = this.state.isPackage;
      procedure["net"] = Net;
    }

    if (updateProcedure) {
      procedures[procedureSelectedIndex] = procedure;
      this.setState({ updateProcedure: false });
    } else {
      procedures.push(procedure);
      totalPrice += procedure["net"];
    }
    console.log(procedures, "nnnnnnnnnnnnnnnn");
    this.setState({
      procedures,
      totalPrice,
      addProceduretotable: true,
      productOrService: {},
      procedure: {},
      proceduresError: "",
      serviceOptions: [],
    });
    this.setState((prevState) => ({
      vitalSignSelectArray,
      keyinfo: prevState.keyinfo + 1,
      allDiagnosisSelect,
      keyDiag: prevState.keyDiag + 1,
      allCareTeamSelect,
      keyCare: prevState.keyCare + 1

    }));

  };
  handleUpdateProcedure = (index) => {
    const {
      procedures,
      productOrService,
      selectedOptions,
      selectOptionsCareTeam,
      selectedOptionsDiagnosis,
      vitalSignSelectArray,
      allCareTeamSelect,
      allDiagnosisSelect
    } = this.state;
    let relatedInfoSequence = [];
    let relatedCareTeamSequence = [];
    let relatedDiagnosisSequence = [];
    const selectedProcedure = procedures[index];
    const { careTeamSequence, informationSequence, diagnosisSequence } =
      selectedProcedure;
    if (careTeamSequence && careTeamSequence.length > 0) {
      relatedCareTeamSequence = careTeamSequence.map(
        (element) => allCareTeamSelect[element - 1]
      );
    }

    if (informationSequence && informationSequence.length > 0) {
      relatedInfoSequence = informationSequence.map(
        (element) => vitalSignSelectArray[element - 1]
      );
    }

    if (diagnosisSequence && diagnosisSequence.length > 0) {
      relatedDiagnosisSequence = diagnosisSequence.map(
        (element) => allDiagnosisSelect[element - 1]
      );
    }
    this.setState({
      updateProcedure: true,
      procedureSelectedIndex: index,
      procedure: selectedProcedure,
      productOrService: {
        code: selectedProcedure.productOrService.code,
        display: selectedProcedure.productOrService.display,
      },
      procedureCodeValue:
        selectedProcedure.productOrService.code +
        "-" +
        selectedProcedure.productOrService.display,
      type: selectedProcedure.productOrService.list,
      code: selectedProcedure.productOrService.code,
      unitPrice: selectedProcedure.unitPrice,
      factor: selectedProcedure.factor,
      quantity: selectedProcedure.quantity,
      tax: selectedProcedure.tax,
      patientShare: selectedProcedure.patientShare,
      procedureAutoCompleteValue: false,
      selectOptionsCareTeam: relatedCareTeamSequence,
      selectedOptionsDiagnosis: relatedDiagnosisSequence,
      selectedOptions: relatedInfoSequence,
    });
  };

  handleDeleteProcedure = (index) => {
    let { procedures, totalPrice } = this.state;
    totalPrice -= procedures[index]["net"];
    this.setState({ totalPrice });
    procedures.splice(index, 1);

    this.setState({ procedures });
    // for (let i=0;i<procedures.length>0;i++){

    // }
    if (JSON.stringify(procedures) == "[]") {
      this.setState({ addProceduretotable: false });
    }
  };

  HandleCareTeamInputTextChange = (e) => {
    let { allDoctors } = this.state;
    let name = e.target.name;
    let value = e.target.value;
    if (name == "practitioner") {
      let selectedDoctor = allDoctors.filter((p) => {
        return p.id == value;
      });
      if (selectedDoctor && selectedDoctor.length > 0) {
        let doctorName = selectedDoctor[0].full_name.split(" ");
        let doctorLastName = "";
        for (let i = 1; i < doctorName.length; i++) {
          doctorLastName += doctorName[i] + " ";
        }
        this.setState({
          practitionerInfo: {
            id: "41561",
            type: {
              code: "MD",
              display: "Medical License number",
              value: selectedDoctor[0].license,
            },
            active: true,
            name: selectedDoctor[0].full_name,
            gender: selectedDoctor[0].gender,
          },
          careInfo: {
            ...this.state.careInfo,
            license: selectedDoctor[0].license,
            firstName: selectedDoctor[0].full_name.split(" ")[0],
            lastName: doctorLastName,
            role: selectedDoctor[0].doctor_role,
            qualification: selectedDoctor[0].specialty,
          },
          practitionerValue: value,
          errorPractitioner: "",
        });
      }
    } else {
      this.setState({ [name]: value });
    }
  };
  handleAddCareTeamInfo = async (e) => {
    e.preventDefault();
    let { careTeams, careInfo, allCareTeamSelect, practitionerValue } =
      this.state;
    if (practitionerValue == "") {
      this.setState({ errorPractitioner: "practitioner is required!" });
    }
    this.setState({ practitionerValue: " " })
    // else {
    if (careTeams.length == 0) {
      careInfo["id"] = 1;
    } else {
      careInfo["id"] = careTeams.indexOf(careInfo) + 1;
    }
    careTeams.push(careInfo);
    if (!allCareTeamSelect) {
      for (let i = 0; i < careTeams.length; i++) {
        allCareTeamSelect.push({
          view:
            careTeams[i].firstName +
            " " +
            careTeams[i].lastName +
            "-" +
            careTeams[i].license,
        });
      }
    } else {
      allCareTeamSelect.push({
        view:
          careInfo.firstName + " " + careInfo.lastName + "-" + careInfo.license,
      });
    }
    this.setState({ careTeams, addCareTeamtotable: true });
    // }
  };
  handleDeleteCareTeam = (index) => {
    let { careTeams, allCareTeamSelect } = this.state;
    careTeams.splice(index, 1);
    allCareTeamSelect.splice(index, 1);
    this.setState({ careTeams });
    if (JSON.stringify(careTeams) == "[]") {
      this.setState({ addCareTeamtotable: false });
    }
  };
  onSelectCategory = (selectedList) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
      selectedOptions: selectedList
    });
  };
  onRemoveCategory = (selectedList, removedItem) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
      selectedOptions: selectedList
    });
  };
  getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };
  handleAttachmentReason = (e) => {
    let reason = e.target.name;
    let value = e.target.value;

    this.setState({
      attachmentReason: { reason: value, reasonDisplay: value }, attReason: value
    });
    if (value == "consent") {
      this.setState({
        consentFormAttached: true
      });
    }

  };

  handleAddFileAttachment = async (e) => {
    this.setState({
      attReason: "",
    })
    let { file, supportingInfo } = this.state;

    if (!file) {
      this.setState({
        errorSizeMessage: "Please select a file first.",
        showError: true,
      });
    }
  
    const maxFileSize = 48 * 1024 * 1024; 
    
    if (file.size > maxFileSize) {
      this.setState({
        errorSizeMessage: "File size exceeds 48 MB, please select a smaller file.",
        showError: true,
      });
      return;
    }

    this.getBase64(file)
      .then((result) => {
        file["base64"] = result.split(",")[1];
        this.setState({
          base64URL: result,
          file,
        });
      })
      .then(() => {
        supportingInfo.push({
          category: "attachment",
          display: "Attachment",
          valueQuantityCode: file.name,
          valueAttachment: {
            contentType: file.type,
            data: file["base64"],
            title: file.name,
            creation: new Date().toISOString(),
          },
          reason: this.state.attachmentReason.reason,
          reasonDisplay: this.state.attachmentReason.reasonDisplay,
        });
        let { vitalSignSelectArray } = this.state;

        vitalSignSelectArray.push({
          view: "attachment" + " " + "" + " " + file.name,
        });
        console.log(vitalSignSelectArray, 'for view')
        this.setState({
          addVitaltotable: true,
          vitalSignSelectArray,
          supportingInfo,
          ///
          attReason: ""
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleFileInputChange = (e) => {
    // this.setState({
    //   file: e.target.files[0],
    // });

    const files = e.target.files;
  let totalSize = 0;
  const maxFileSize = 48 * 1024 * 1024; // 48 MB in bytes
  
  for (let i = 0; i < files.length; i++) {
    totalSize += files[i].size;
    
    if (files[i].size > maxFileSize) {
      this.setState({
        errorSizeMessage: "File size exceeds 48 MB, please select a smaller file.",
        showError: true,
      });
    }
  }

  if (totalSize > maxFileSize) {
    this.setState({
      errorSizeMessage: "Total file size exceeds 48 MB, please select smaller files.",
      showError: true,
    });
  }else{
    this.setState({
      file: files[0],
      errorSizeMessage: "",
      showError:false,
    });
  }
 
  };


  handleAuthorization = async (e) => {
    e.preventDefault();

    this.setState({
      requestSent: true,
      response: false,
      Autherror: "",
      errorValidForm: "",
      authErrors: [],
    });

    let {
      selectedPatient,
      encounter,
      practitionerInfo,
      claimTypeValue,
      claimSubTypeValue,
      priorityValue,
      encounterClassValue,
      enconterStatusValue,
      prescriberValue,
    } = this.state;
    let formIsValid = true;
    let authID = Number(String(Math.floor(Math.random() * 1e9)).padStart(9, '0'));
    let encounterID = Math.floor(Math.random() * 100000).toString();
    this.setState({ authID, encounterID });


    if (claimTypeValue == "") {
      this.setState({ errorClaimType: "Claim Type is required !" });
      formIsValid = false;
    }
    if (claimSubTypeValue == "") {
      this.setState({ errorClaimSubType: "Claim Sub Type is required !" });
      formIsValid = false;
    }
    if (priorityValue == "") {
      this.setState({ errorpriority: "priority is required !" });
      formIsValid = false;
    }
    if (encounterClassValue == "") {
      this.setState({ errorClassValue: "class is required !" });
      formIsValid = false;
    }
    if (enconterStatusValue == "") {
      this.setState({ errorStatusValue: "Status is required !" });
      formIsValid = false;
    }
    if (prescriberValue == "") {
      this.setState({ errorPrescriber: "Prescriber is required !" });
      formIsValid = false;
    }
    if (!practitionerInfo || this.state.careTeams.length == 0) {
      this.setState({ errorPractitioner: "practitioner is required !" });
      formIsValid = false;
    }
    if (this.state.procedures.length == 0) {
      this.setState({ proceduresError: "procedures is required !" });
      formIsValid = false;
    }
    if (!formIsValid) {
      this.setState({ errorValidForm: "Please fill out all required fields." });
      return; // Don't proceed with form submission if there are errors
    }
    if (!this.state.consentFormAttached) {
      this.setState({ errorValidForm: "Please attach the patient consent form." });
    } else {
      let patient = {
        firstName: selectedPatient.first_name,
        lastName: selectedPatient.last_name,
        identifier: selectedPatient.identifier,
        profileId: selectedPatient.profile_id,
        gender: selectedPatient.gender,
        birthDate: selectedPatient.birthdate,
        phone: selectedPatient.phone,
        identifierType: selectedPatient.identifier_type,
        country: selectedPatient.country,
      };
      let { coverage } = selectedPatient;
      // console.log(coverage ,'jjjjjjjjjjjjjjjjjjjjjcoverage')
      coverage["patientId"] = selectedPatient.profile_id;
      try {
        let response = await axios.post(
          KayanURL + "/test/comp/request",

          {
            apiToken: Cookies.get("id"),
            requestType: "2",
            content: {
              payerName: selectedPatient.payer_name,
              providerName: selectedPatient.provider_name, //this.state.providerDhamaniID,
              payerId: selectedPatient.payer_id,
              providerId: selectedPatient.provider_name,
              patientId: selectedPatient.profile_id,
              patient: patient,
              encounter: {
                id: encounterID,
                type: encounter.type,
                identifier: encounter.identifier,
                status: encounter.status,
                class: encounter.class,
                patientId: selectedPatient.profile_id,
                period: {
                  start: encounter.start,
                  end: encounter.end,
                },
                providerId: selectedPatient.provider_name,
              },
              coverage: coverage,
              practitioner: practitionerInfo,
              claim: {
                providerName: selectedPatient.provider_name,
                payerId: "6",
                providerId: "1",
                patientId: selectedPatient.profile_id,
                claimType: this.state.claimType,
                claimSubType: this.state.claimSubType,
                created: this.state.dateOrdered,
                use: "preauthorization",
                encounterID,
                status: "active",
                coverageBundleId: coverage.coverageEligibilitResponseId
                  ? coverage.coverageEligibilitResponseId
                  : "",
                id: authID,
                priority: this.state.priority,
                diagnosis: this.state.allDiagnosis,
                careTeam: this.state.careTeams,
                supportingInfo: this.state.supportingInfo,
                items: this.state.procedures,
                prescriber: this.state.prescriberInfo,
                insurance: [
                  {
                    focal: true,
                    coverageId: coverage.id,
                  },
                ],
                total: this.state.totalPrice,
              },
              specificIns: this.props.tpa ? this.props.tpa : 
              (selectedPatient.tpa && selectedPatient.tpa.trim() !== "" ? selectedPatient.tpa : "unkown"),
              isTPA: this.props.tpa ? true : selectedPatient.tpa && selectedPatient.tpa.trim() !== "" ? true : false,

            },
          }
        );
        console.log(selectedPatient.tpa ,"selectedPatient.tpa ")

        if (response) {
          this.setState({
            requestSent: false,
            response: true,
          });
          let { data } = response;
          if (data) {
            let { success, error, response, fullResponse, HL7Request } = data;
            this.setState({ HL7Request: JSON.parse(HL7Request) })
            if (success) {
              let {
                outcome,
                authorizationRequestIdentifier,
                authorizationResponseIdentifier,
                requestBundleID,
                responseBundleID,
              } = data.response;
              this.setState({
                outcome: outcome,
                authorizationRequestIdentifier: authorizationRequestIdentifier,
                authorizationResponseIdentifier: authorizationResponseIdentifier,
              });
              if (outcome == "complete") {
                let { items, Total, preAuthRef, adjudicationOutcome } =
                  data.response;
                this.addAuthResponseInfo(
                  outcome,
                  authorizationRequestIdentifier,
                  authorizationResponseIdentifier,
                  authID,
                  encounterID,
                  [],
                  items,
                  Total,
                  preAuthRef,
                  adjudicationOutcome,
                  requestBundleID,
                  responseBundleID,
                  fullResponse,
                  this.props.tpa ? this.props.tpa : selectedPatient.tpa != null ? selectedPatient.tpa:"",
                );
                if (items && items.length > 0) {
                  this.setState({
                    items,
                    Total,
                    diagnosisCode: {},
                    productOrService: {},
                  });
                }
              } else if (outcome == "queued") {
                this.addAuthResponseInfo(
                  outcome,
                  authorizationRequestIdentifier,
                  authorizationResponseIdentifier,
                  authID,
                  encounterID,
                  [],
                  [],
                  [],
                  "",
                  "",
                  requestBundleID,
                  responseBundleID,
                  fullResponse,
                  this.props.tpa ? this.props.tpa : selectedPatient.tpa != null ? selectedPatient.tpa:"",
                );
              } else if (outcome == "error") {
                this.addAuthResponseInfo(
                  outcome,
                  authorizationRequestIdentifier,
                  authorizationResponseIdentifier,
                  authID,
                  encounterID,
                  data.response.errors,
                  [],
                  [],
                  "",
                  "",
                  requestBundleID,
                  responseBundleID,
                  fullResponse,
                  this.props.tpa ? this.props.tpa : selectedPatient.tpa != null ? selectedPatient.tpa:"",
                );
                this.setState({ authErrors: data.response.errors });
              }
              this.setState({ totalPrice: 0 });
            } else {
              this.setState({ Autherror: response ? response : error });
            }
          }
        }
      } catch (error) {
        let errorMessage = "An error occurred while pre authorization. Please try again later.";
        if (error.message.includes("400")) {
          errorMessage = "Server is not responding.";
        } else if (error.message.includes("500")) {
          errorMessage = "There is an internal server error. Please contact the IT team to resolve this issue.";
        }
        this.setState({
          requestSent: false,
          response: true,
          Autherror: errorMessage,
        });
      }
    }
    // console.log(selectedPatient ,'jjjjjjjjjjjjjjjjjjjjj')

  };

  addAuthResponseInfo = async (
    outcome,
    authorizationRequestIdentifier,
    authorizationResponseIdentifier,
    authID,
    encounterID,
    errors,
    items,
    Total,
    preAuthRef,
    adjudicationOutcome,
    requestBundleID,
    responseBundleID,
    fullResponse,
    tpa
  ) => {
    let currentDate = new Date();
    let formattedDate = `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1
    ).padStart(2, "0")}-${String(currentDate.getDate()).padStart(
      2,
      "0"
    )}T${String(currentDate.getHours()).padStart(2, "0")}:${String(
      currentDate.getMinutes()
    ).padStart(2, "0")}`;
    let { selectedPatient, encounter, practitionerInfo } = this.state;
    let { coverage } = selectedPatient;
    coverage["patientId"] = selectedPatient.profile_id;
    try {
      let tmpSupportingInformation = this.state.supportingInfo.filter(
        (item) => item.category != "attachment"
      );
      let response = await axios.put(
        KayanURL + "/test/patients/authorization/addAuthorization",

        {
          apiToken: Cookies.get("id"),
          authorization: {
            payer_name: selectedPatient.payer_name,
            provider_name: selectedPatient.provider_name,
            payer_id: selectedPatient.payer_id,
            provider_id: selectedPatient.provider_name,
            patient_id: selectedPatient.patient_serial_id ? selectedPatient.patient_serial_id : selectedPatient.id,
            encounter: {
              id: encounterID,
              type: encounter.type,
              identifier: encounter.identifier,
              status: encounter.status,
              class: encounter.class,
              patientId: selectedPatient.profile_id,
              period: {
                start: encounter.start,
                end: encounter.end,
              },
              providerId: selectedPatient.provider_name,
            },
            coverage: coverage,
            practitioner: practitionerInfo,
            claim: {
              providerName: selectedPatient.provider_name,
              payerId: "6",
              providerId: "1",
              patientId: selectedPatient.profile_id,
              claimType: this.state.claimType,
              claimSubType: this.state.claimSubType,
              created: this.state.dateOrdered,
              use: "preauthorization",
              encounterId: encounter.id,
              status: "active",
              coverageBundleId: coverage.coverageEligibilitResponseId
                ? coverage.coverageEligibilitResponseId
                : "",
              id: authID,
              priority: this.state.priority,
              diagnosis: this.state.allDiagnosis,
              careTeam: this.state.careTeams,
              supportingInfo: this.state.supportingInfo,
              items: this.state.procedures,
              prescriber: this.state.prescriberInfo,
              insurance: [
                {
                  focal: true,
                  coverageId: coverage.id,
                },
              ],
              total: this.state.totalPrice,
            },
            outcome: outcome,
            authorizationRequestIdentifier: authorizationRequestIdentifier,
            authorizationResponseIdentifier: authorizationResponseIdentifier,
            errors: errors,
            items: items,
            total: Total,
            preAuthRef: preAuthRef,
            adjudicationOutcome: adjudicationOutcome,
            requestBundleID: requestBundleID,
            responseBundleID: responseBundleID,
            formattedDate: formattedDate,
            hl7response: fullResponse,
            tpa: tpa,
          },
        }
      );
      if (response) {
        let { data } = response;
        if (data) {
          let { success, error } = data;
          if (success) {
            console.log(success);
          } else {
            console.log(error);
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  generatePdf = () => {
    if (this.pdfGeneratorRef.current) {
      this.pdfGeneratorRef.current.generateDocument();
    }
  };
  toggleRowVisibility = () => {
    this.setState({ showRow: !this.state.showRow });
  };

  // generateDocument = () => {
  //   const { selectedPatient } = this.state;

  //   let patientInfo;

  //   // If no patient is selected, prepare the message
  //   if (!selectedPatient) {
  //     patientInfo = {
  //       noPatientMessage: 'No patient selected',
  //     };
  //   } else {
  //     // Prepare patient information
  //     patientInfo = {
  //       first_name: selectedPatient.first_name,
  //       last_name: selectedPatient.last_name,
  //       provider: selectedPatient.provider_name,
  //       patientId: selectedPatient.coverage.patientId,
  //       dob: selectedPatient.birthdate,
  //       gender: selectedPatient.gender,
  //       phone: selectedPatient.phone,
  //       status: selectedPatient.disposition,
  //     };
  //   }

  //   loadFile(
  //     'https://docxtemplater.com/ang-example.docx',
  //     function (error, content) {
  //       if (error) {
  //         throw error;
  //       }

  //       const zip = new PizZip(content);
  //       const doc = new Docxtemplater(zip, {
  //         paragraphLoop: true,
  //         linebreaks: true,
  //         parser: expressionParser,
  //       });

  //       // Render patient information
  //       doc.setData(patientInfo);

  //       try {
  //         // Apply the data to the template
  //         doc.render();
  //       } catch (error) {
  //         // Handle render errors
  //         console.error('Error rendering document:', error);
  //         return;
  //       }

  //       // Generate the document
  //       const out = doc.getZip().generate({
  //         type: 'blob',
  //         mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  //       });

  //       // Save the document
  //       saveAs(out, 'output.docx');
  //     }
  //   );
  // };

  // delayedGeneratePDF = () => {
  //   setTimeout(this.generatePDF, 1000); // Adjust the delay time as needed
  // }
  // generatePDF = async () => {
  //     const pdfDoc = await PDFDocument.create();
  //     const page = pdfDoc.addPage();
  //     const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
  //     const { selectedPatient,productOrService } = this.state;

  //     const { width, height } = page.getSize();
  //     const fontSize = 14;
  //     const x = 50;
  //     let y = height - 50;

  //     if (!selectedPatient) {
  //       page.drawText('No patient selected', { x, y, size: fontSize, font: timesRomanFont });
  //     } else {
  //     if (selectedPatient) {
  //       const patientInfo = {
  //         provider: selectedPatient.provider_name,
  //         name: `${selectedPatient.first_name} ${selectedPatient.last_name}`,
  //         patientId: selectedPatient.coverage.patientId,
  //         dob: selectedPatient.birthdate,
  //         gender: selectedPatient.gender,
  //         phone: selectedPatient.phone,
  //         status: selectedPatient.disposition,
  //       };
  //       page.drawText(`Provider Name: ${patientInfo.provider}`, { x, y, size: fontSize, font: timesRomanFont });
  //       y -= 30;
  //       page.drawText(`Patient Name: ${patientInfo.name}`, { x, y, size: fontSize, font: timesRomanFont });
  //       y -= 30;
  //       page.drawText(`Patient ID: ${patientInfo.patientId}`, { x, y, size: fontSize, font: timesRomanFont});
  //       y -= 30;
  //       page.drawText(`DOB: ${patientInfo.dob}`, { x, y, size: fontSize, font: timesRomanFont});
  //       y -= 30;
  //       page.drawText(`Gender: ${patientInfo.gender}`, { x, y, size: fontSize, font: timesRomanFont });
  //       y -= 30;
  //       page.drawText(`Patient no: ${patientInfo.phone}`, { x, y, size: fontSize, font: timesRomanFont});
  //       y -= 30;
  //       page.drawText(`Status: ${patientInfo.status}`, { x, y, size: fontSize, font: timesRomanFont });
  //       y -= 50;
  //     }
  //     if (productOrService && productOrService.code && productOrService.display) {
  //       y -= 30;
  //       page.drawText(`Code: ${productOrService.code}`, { x, y, size: fontSize, font: timesRomanFont });
  //       y -= 30;
  //       page.drawText(`Description: ${productOrService.display}`, { x, y, size: fontSize, font: timesRomanFont });
  //       y -= 50;
  //   }
  //    }

  //     const pdfBytes = await pdfDoc.save();
  //     const blob = new Blob([pdfBytes], { type: 'application/pdf' });
  //     const link = document.createElement('a');
  //     link.href = window.URL.createObjectURL(blob);
  //     link.download = 'patient_information.pdf';
  //     link.click();

  // };
  downloadJsonFile = () => {
    const blob = new Blob([JSON.stringify(this.state.HL7Request, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'data.json';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  render() {
    console.log(this.state.consentFormAttached, "errorValidForm")
    // const data = {
    //   provider_name_license: 'Provider Name and license Number',
    //   beneficiary_name: 'Beneficiary Name',
    //   document_id: 'Document Type - Document ID',
    //   insurance_company: 'Insurance Company Name / TPA',
    //   insurance_id: 'Insurance ID',
    //   beneficiary_age: 'Calculated from date of birth',
    //   beneficiary_gender: 'Gender',
    //   relationship: 'Relationship',
    //   contact_number: 'Beneficiary\'s phone number',
    // };
    const { selectedPatient, nonStandardCodeOptions, procedure } = this.state;
    console.log(selectedPatient, "coooooooooo");
    console.log(this.props.tpa , 'tpa')
    console.log("this.props.selectedPatient:", this.props.selectedPatient);

    
    let {
      careTeams,
      allDiagnosis,
      procedures,
      supportingInfo,
      items,
      Total,
      allPatients,
      allDoctors,
      authErrors,
    } = this.state;
    let careTeamRows = [],
      diagnosisRows = [],
      procedureRows = [],
      allVitalRows = [];
    let itemRows = [],
      totalRows = [],
      errorRows = [],
      doctorRows;

    if (allDoctors && allDoctors.length > 0) {
      doctorRows = allDoctors.map((element, index) => {
        return <option value={element.id}>{element.full_name}</option>;
      });
    }
    if (careTeams && careTeams.length > 0) {
      careTeamRows = careTeams.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.firstName}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.lastName}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.license}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.role}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.qualification}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteCareTeam(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
    }
    if (allDiagnosis && allDiagnosis.length > 0) {
      diagnosisRows = allDiagnosis.map((element, index) => {
        // if(element.onAdmission=="undefined"){
        //   element.onAdmission =" "
        // }
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {index + 1}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code.text}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.onAdmission && element.onAdmission != "undefined"
                ? element.onAdmission
                : null}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteDiagnosis(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
              <IconButton
                onClick={() => {
                  this.handleUpdateDiagnosis(index);
                }}
              >
                <EditIcon color="green" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
        console.log("response:", allDiagnosis);
      });
    }
    if (procedures && procedures.length > 0) {
      procedureRows = procedures.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.productOrService.code}
              {""}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.productOrService.list}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.productOrService.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.unitPrice}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.tax}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.patientShare}{" "}
            </TableCell>
            {element.careTeamSequence && element.careTeamSequence.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.careTeamSequence.toString()}{" "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}

            {element.diagnosisSequence &&
              element.diagnosisSequence.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.diagnosisSequence.toString()}{" "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}
            {element.informationSequence &&
              element.informationSequence.length > 0 ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.informationSequence.toString()}{" "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}

            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteProcedure(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
              <IconButton
                onClick={() => {
                  this.handleUpdateProcedure(index);
                }}
              >
                <EditIcon color="green" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
    }
    if (supportingInfo && supportingInfo.length > 0) {
      console.log(supportingInfo, "vvvvvvvvvvvvvvvvv");
      allVitalRows = supportingInfo.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {index + 1}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.category}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.category != "attachment" ? `${element.valueQuantity} ${element.unit}` :
                `${element.valueQuantityCode}`}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteVital(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
    }
    if (items && items.length > 0) {
      itemRows = items.map((element, index) => {
        const adjudicationRows = element.adjudications.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.category}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.amount}
              </TableCell>
            </TableRow>
          );
        });

        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.itemSequence}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.outcome}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <TableContainer
                component={Paper}
                style={{
                  margin: "auto",
                  width: "100%",
                }}
              >
                <Table aria-label="simple table">
                  <TableHead style={{ backgroundColor: "#fafafa" }}>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell align="center">Category</TableCell>
                      <TableCell align="center">Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{adjudicationRows}</TableBody>
                </Table>
              </TableContainer>
            </TableCell>
          </TableRow>
        );
      });
    }
    if (Total && Total.length > 0) {
      totalRows = Total.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.category}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.amount}{" "}
            </TableCell>
          </TableRow>
        );
      });
    }
    if (authErrors && authErrors.length > 0) {
      errorRows = authErrors.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.extension}{" "}
            </TableCell>
          </TableRow>
        );
      });
    }
    let options = [],
      PatientRows = [],
      defaultOptionValue = [];
    if (allPatients) {
      for (let i = 0; i < allPatients.length; i++) {
        options.push({
          value: allPatients[i].profile_id,
          label: allPatients[i].first_name + " " + allPatients[i].last_name,
        });
      }
      if (this.props.selectedPatient) {
        defaultOptionValue = options.filter((p) => {
          return p.value == this.props.selectedPatient.profile_id;
        });
      }
    }
    return (
      <>
        {this.props.flag ? <Box height={0} /> : <Box height={60} />}
        <div
          style={{
            textAlign: "left",
            boxShadow: "1px solid grey",
            padding: "15px",
            boxShadow:
              "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
            borderRadius: "10px",
          }}
        >
          <div>
            <div style={{ width: "100%", margin: "auto", padding: "20px" }}>
              <Accordion
                defaultActiveKey="0"
                style={{
                  width: "100%",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>Authorization Information</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <FormControl style={{ width: "100%" }}>
                      <Container>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Date Ordered
                              </Form.Label>
                              <Form.Control
                                type="datetime-local"
                                name="dateOrdered"
                                onChange={this.HandleInputTextChange}
                                value={this.state.dateOrdered}
                              // placeholder={this.state.dateOrdered}
                              // onFocus={(e) => e.target.type = 'date'}
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Claim Type *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleInputTextChange}
                                required
                                name="claimType"
                                value={this.state.claimTypeValue}
                              >
                                <option value="0">select Type</option>
                                <option value="institutional">
                                  Institutional
                                </option>
                                <option value="professional">
                                  Professional
                                </option>
                                <option value="oral">Dental</option>
                                <option value="pharmacy">Pharmacy</option>
                                <option value="vision">Optical</option>
                              </Form.Select>
                              {this.state.errorClaimType ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorClaimType}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Claim Sub Type *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleInputTextChange}
                                required
                                name="claimSubType"
                                value={this.state.claimSubTypeValue}
                              >
                                <option value="0">select Sub Type</option>
                                <option value="ip">InPatient</option>
                                <option value="op">OutPatient</option>
                                <option value="emr">Emergency</option>
                              </Form.Select>
                              {this.state.errorClaimSubType ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorClaimSubType}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Prescriber *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleInputTextChange}
                                required
                                name="prescriber"
                                value={this.state.prescriberValue}
                              >
                                <option value="0">select Prescriber</option>
                                {doctorRows}
                              </Form.Select>
                              {this.state.errorPrescriber ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorPrescriber}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Label style={{ fontSize: "13px" }}>
                              Patients
                            </Form.Label>

                            <div id="form-group">
                              <Select
                                onChange={(e) => this.onSelectValue(e)}
                                options={options}
                                isSearchable="true"
                                isDisabled="true"
                                // defaultInputValue={defaultOptionValue&&defaultOptionValue.length>0?defaultOptionValue[0]:""}
                                placeholder={
                                  defaultOptionValue &&
                                    defaultOptionValue.length > 0
                                    ? defaultOptionValue[0].label
                                    : "select..."
                                }
                              ></Select>
                            </div>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Priority *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleInputTextChange}
                                required
                                name="priority"
                              >
                                <option value="0">select Priority</option>
                                <option value="normal">Normal</option>
                                <option value="stat">Immediate</option>
                                <option value="deferred">Deferred</option>
                              </Form.Select>

                              {this.state.errorpriority ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorpriority}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                        </Row>
                      </Container>
                    </FormControl>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion
                defaultActiveKey="0"
                style={{
                  width: "100%",
                  margin: "20px 0",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>Care Team</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <FormControl style={{ width: "100%" }}>
                      <Container>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Practitioner *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleCareTeamInputTextChange}
                                required
                                name="practitioner"
                                value={this.state.practitionerValue}
                              >
                                <option value="0">select Practitioner</option>
                                {doctorRows}
                              </Form.Select>
                              {this.state.errorPractitioner ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorPractitioner}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                          <Col>
                            {/* <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Gender *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleCareTeamInputTextChange}
                                required
                                name="doctorGender"
                              >
                                <option value="0">select...</option>
                                <option value="female">Female</option>
                                <option value="male">Male</option>
                              </Form.Select>
                            </Form.Group> */}
                            <div style={{ marginTop: "30px" }}>
                              <Button
                                variant="primary"
                                type="submit"
                                onClick={(e) => this.handleAddCareTeamInfo(e)}
                                style={{
                                  width: "25%",
                                  backgroundColor: "rgb(78 75 75)",
                                  border: "1px solid rgb(78 75 75)",
                                }}
                              >
                                <AddIcon style={{ fontSize: "19px" }} /> Add
                              </Button>
                            </div>
                          </Col>
                          <Col></Col>

                          {this.state.addCareTeamtotable &&
                            careTeams &&
                            careTeams.length > 0 ? (
                            <div style={{ marginTop: "10px" }}>
                              <hr />

                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "auto",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">
                                        First Name
                                      </TableCell>
                                      <TableCell align="center">
                                        Last Name
                                      </TableCell>
                                      <TableCell align="center">
                                        License
                                      </TableCell>
                                      <TableCell align="center">Role</TableCell>
                                      <TableCell align="center">
                                        Speciality
                                      </TableCell>
                                      <TableCell align="center">
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>{careTeamRows}</TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : null}
                        </Row>
                      </Container>
                    </FormControl>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion
                defaultActiveKey="0"
                style={{
                  width: "100%",
                  margin: "20px 0",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>Diagnosis And Supporting Info</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <FormControl style={{ width: "100%" }}>
                      <Container>
                        <Row>
                          <div style={{ marginBottom: "10px" }}>
                            <span>Diagnosis</span>
                          </div>
                          <div style={{ width: "30%" }}>
                            <Col>
                              <FormControl sx={{ mb: 3, width: "100%" }}>
                                {this.state.isDataFetched ? (
                                  <Autocomplete
                                    suggestions={this.state.codeOptions}
                                    onChangeSetCode={this.handleDiagnosisSelect}
                                    flag={this.state.DiagnosisAutoCompleteValue}
                                    value={this.state.diagnosisCodeValue}
                                    name="code"
                                  />
                                ) : (
                                  <Spinner
                                    animation="border"
                                    variant="success"
                                  />
                                )}
                              </FormControl>
                            </Col>
                          </div>
                          <div style={{ width: "30%" }}>
                            <Col>
                              <Form.Group className="mb-3">
                                <Form.Select
                                  style={{ padding: "9px" }}
                                  onChange={this.HandleDiagnosisInputTextChange}
                                  // required
                                  value={this.state.diagnosisType}
                                  name="type"
                                >
                                  <option value="0">select Type</option>
                                  <option value="principal">
                                    Principal Diagnosis
                                  </option>
                                  <option value="secondary">
                                    Secondary Diagnosis
                                  </option>
                                  <option value="admitting">
                                    Admitting Diagnosis
                                  </option>
                                  <option value="differential">
                                    Differential Diagnosis
                                  </option>
                                  <option value="discharge">
                                    Discharge Diagnosis
                                  </option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </div>
                          <div style={{ width: "30%" }}>
                            <Col>
                              <Form.Group className="mb-3">
                                <Form.Select
                                  style={{ padding: "9px" }}
                                  onChange={this.HandleDiagnosisInputTextChange}
                                  value={this.state.onAdmissionValue}
                                  name="onAdmission"
                                  disabled={this.state.onAdmissionDisabled}
                                >
                                  <option value="undefined">
                                    select On Admission
                                  </option>
                                  <option value="y">Yes</option>
                                  <option value="n">No</option>
                                  <option value="u">Unknown</option>
                                  <option value="w">
                                    {" "}
                                    Clinically undetermined
                                  </option>
                                  <option value="1">Unreported/Not used</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </div>
                          <div style={{ width: "4%" }}>
                            <Col>
                              <div>
                                <Button
                                  variant="primary"
                                  type="submit"
                                  onClick={(e) => this.handleAddDiagnosis(e)}
                                  style={{
                                    backgroundColor: "rgb(78 75 75)",
                                    border: "1px solid rgb(78 75 75)",
                                  }}
                                >
                                  {this.state.updateDiagnosis ? (
                                    <BookmarkBorderIcon
                                      style={{ fontSize: "19px" }}
                                    />
                                  ) : (
                                    <AddIcon style={{ fontSize: "19px" }} />
                                  )}
                                </Button>
                              </div>
                            </Col>
                          </div>
                          {this.state.errorMessage && (
                            <p style={{ color: "red" }}>
                              {this.state.errorMessage}
                            </p>
                          )}

                          {this.state.addDiagnosistotable &&
                            allDiagnosis &&
                            allDiagnosis.length > 0 ? (
                            <div style={{ marginTop: "10px" }}>
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "10px auto 10px",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">ID</TableCell>
                                      <TableCell align="center">Code</TableCell>
                                      <TableCell align="center">Type</TableCell>
                                      <TableCell align="center">
                                        Description
                                      </TableCell>
                                      <TableCell align="center">
                                        On Admission
                                      </TableCell>
                                      <TableCell align="center">
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>{diagnosisRows}</TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : null}
                        </Row>
                        <Row>
                          <hr />
                          <div style={{ marginBottom: "10px" }}>
                            <span>Supporting Information</span>
                          </div>

                          <div style={{ width: "30%" }}>
                            <Col>
                              <Form.Group className="mb-3">
                                <Form.Select
                                  onChange={this.HandleVitalSignInputTextChange}
                                  // required
                                  name="category"
                                  value={this.state.category}
                                >
                                  <option value="0">select Category</option>
                                  <option value="vital-sign-diastolic">
                                    {" "}
                                    Diastolic
                                  </option>
                                  <option value="vital-sign-systolic">
                                    Systolic
                                  </option>
                                  <option value="vital-sign-height">
                                    Height
                                  </option>
                                  <option value="vital-sign-weight">
                                    Weight{" "}
                                  </option>
                                  <option value="days-supply">
                                    Days Supply{" "}
                                  </option>
                                  <option value="icu-hours">ICU Hours</option>
                                  <option value="ventilation-hours">
                                    {" "}
                                    Ventilation Hours{" "}
                                  </option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </div>
                          <div style={{ width: "30%" }}>
                            <Col>
                              <Form.Control
                                type="text"
                                name="valueQuantity"
                                onChange={this.HandleVitalSignInputTextChange}
                                // required
                                value={this.state.valueQuantity}
                                placeholder="Enter value"
                              />
                            </Col>
                          </div>
                          <div style={{ width: "30%" }}>
                            {/* <Col>
                              <Form.Group className="mb-3">
                                <Form.Select
                                  onChange={this.HandleVitalSignInputTextChange}
                                  // required
                                  // disabled
                                  value={this.state.valueQuantityCode}
                                  name="valueQuantityCode"
                                >
                                  <option value="0">select Unit</option>
                                  <option value="mm[Hg]">mm[Hg]</option>
                                  <option value="kg">kg</option>
                                  <option value="d">Day</option>
                                  <option value="h">Hour</option>
                                  <option value="cm">CM</option>
                                  {/* <option value="Cel">Cel</option> */}
                            {/* <option value="/min">/min</option> */}
                            {/* <option value="pT">pT</option> */}
                            {/* </Form.Select>
                              </Form.Group>
                            </Col> */}
                            <Col>
                              <div style={{ width: "10%" }}>
                                <Button
                                  variant="primary"
                                  type="submit"
                                  onClick={(e) =>
                                    this.handleAddSupportingInfo(e)
                                  }
                                  style={{
                                    backgroundColor: "rgb(78 75 75)",
                                    border: "1px solid rgb(78 75 75)",
                                  }}
                                >
                                  <AddIcon style={{ fontSize: "19px" }} />
                                </Button>
                              </div>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <hr />
                          <div style={{ marginBottom: "10px" }}>
                            <span>Attachments</span>
                          </div>
                          <Col>
                            <Form.Control
                              type="file"
                              onChange={this.handleFileInputChange}
                            />
                          </Col>
                          <Col xs={3}>
                            <Form.Group className="mb-3">
                              <Form.Select
                                onChange={this.handleAttachmentReason}
                                // required
                                // disabled
                                value={this.state.attReason}
                                name="attReason"
                              >
                                <option value="0">select Reason</option>
                                <option value="consent">
                                  patient consent form
                                </option>
                                <option value="miss">
                                  Missing information
                                </option>
                                <option value="acknowledgement">
                                  patient acknowledgement form
                                </option>
                                <option value="att">Missing attachment</option>
                                <option value="cor">
                                  Information correction
                                </option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <div style={{ width: "13%" }}>
                            <Col>
                              <Button
                                variant="primary"
                                type="submit"
                                onClick={(e) => this.handleAddFileAttachment(e)}
                                style={{
                                  backgroundColor: "rgb(78 75 75)",
                                  border: "1px solid rgb(78 75 75)",
                                }}
                              >
                                <AddIcon style={{ fontSize: "19px" }} />
                              </Button>
                            </Col>
                          </div>
                          {this.state.showError && (
                            <div style={{ color: 'red', marginTop: '10px' }}>
                              {this.state.errorSizeMessage}
                            </div>
                          )}
                          {this.state.addVitaltotable &&
                            this.state.supportingInfo &&
                            this.state.supportingInfo.length > 0 ? (
                            <>
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "20px auto 20px",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">ID</TableCell>
                                      <TableCell align="center">
                                        Category
                                      </TableCell>
                                      <TableCell align="center">
                                        Value
                                      </TableCell>
                                      <TableCell align="center">
                                        Action
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>{allVitalRows}</TableBody>
                                </Table>
                              </TableContainer>
                            </>
                          ) : null}
                          <hr />
                          {
                            /*                           
                          <div style={{ marginBottom: "10px" }}>
                            <span>Generate consent form file</span>
                          </div>
                          {//* <Col>
                            <Form.Control
                              type="file"
                              onChange={this.handleFileInputChange}
                            />
                          </Col> */
                            //}/
                            /*
                          <div style={{ width: "100%" }}>
                            <Col>
                            <Button
                              variant="success"
                              onClick={this.generatePdf} 
                            >
                              Generate PDF
                            </Button>
                            {/* <Button onClick={this.generateDocument}>Generate document</Button> */
                          }
                          {/* {selectedPatient && ( */
                          /*}
                              <PDFGenerator ref={(ref) => (this.pdfGeneratorRef = ref)} showPDF={false} />
                            {/* )} */
                          /*}
                            
                            {/* <button onClick={this.generatePDF}>Generate Consent Form</button> */
                          /*}
                            </Col>
                          </div> */}
                        </Row>
                        <div>
                          <Row>
                            <div style={{ marginBottom: "10px" }}>
                              <span>Consent Form File</span>
                            </div>
                            <Col>

                              <Button
                                variant="success"
                                onClick={this.generatePdf}
                              >
                                Generate PDF
                              </Button>

                            </Col>
                          </Row>
                          <PDFGenerator ref={this.pdfGeneratorRef} />
                        </div>


                      </Container>
                    </FormControl>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion
                defaultActiveKey="0"
                style={{
                  width: "100%",
                  margin: "20px 0",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>Items Information</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <FormControl style={{ width: "100%" }}>
                      <Container>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Type *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleProcedureInputTextChange}
                                // required
                                name="type"
                                value={this.state.type}
                              >
                                <option value="0">select Type</option>
                                <option value="CDT">CDT</option>
                                <option value="CPT">CPT</option>
                                <option value="MEDICATION">Medication</option>
                                <option value="OSL">OSL</option>
                              </Form.Select>
                              {this.state.errorItemType ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "10px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorItemType}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                          <Col>
                            <FormControl sx={{ mb: 3, width: "100%" }}>
                              <Form.Label style={{ fontSize: "13px" }}>
                                Code
                              </Form.Label>
                              <Autocomplete
                                sx={{
                                  ".css-1x51dt5-MuiInputBase-input-MuiInput-input":
                                  {
                                    marginTop: "2px",
                                    border: "1px solid #80808080",
                                    borderRadius: "5px",
                                    paddingTop: "4px",
                                  },
                                }}
                                suggestions={this.state.serviceOptions}
                                onChangeSetCode={this.handleItemCodeSelect}
                                value={this.state.procedureCodeValue}
                                flag={this.state.procedureAutoCompleteValue}
                                name="code"
                              />
                            </FormControl>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Requested QTY
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="quantity"
                                // required
                                value={this.state.quantity}
                                onChange={this.HandleProcedureInputTextChange}
                                placeholder="Enter Qty"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <hr />
                        <span>Calculations</span>
                        <Row>
                          <div style={{ width: "43%" }}>
                            <Col>
                              <Row>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Unit Price *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="unitPrice"
                                      required
                                      value={this.state.unitPrice}
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorPrice ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorPrice}
                                    </span>
                                  ) : null}
                                </Col>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Factor *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="factor"
                                      required
                                      value={this.state.factor}
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorFactor ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorFactor}
                                    </span>
                                  ) : null}
                                </Col>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Tax *
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="tax"
                                      required
                                      value={
                                        this.state.tax
                                          ? this.state.tax
                                          : this.state.tax === 0
                                            ? this.state.tax
                                            : ""
                                      }
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorTax ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorTax}
                                    </span>
                                  ) : null}
                                </Col>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Patient Share *
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="patientShare"
                                      required
                                      value={
                                        this.state.patientShare
                                          ? this.state.patientShare
                                          : this.state.patientShare === 0
                                            ? this.state.patientShare
                                            : ""
                                      }
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorPatientShare ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorPatientShare}
                                    </span>
                                  ) : null}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                          <div
                            style={{
                              width: "14%",
                              margin: "auto",
                              textAlign: "center",
                            }}
                          >
                            <Col>
                              <EastIcon />
                            </Col>
                          </div>
                          <div style={{ width: "43%" }}>
                            <Col>
                              <Row>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Tax Amount *
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="TaxAmount"
                                      // required
                                      readOnly
                                      value={
                                        this.state.quantity ?
                                          this.state.tax && this.state.tax === 0 ? this.state.tax :
                                            this.state.quantity * this.state.tax

                                          : ""
                                      }
                                    // onChange={this.HandleProcedureInputTextChange}
                                    />
                                  </Form.Group>
                                  {this.state.errorTaxAmount ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorTaxAmount}
                                    </span>
                                  ) : null}
                                </Col>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Net *
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="net"
                                      // required
                                      readOnly
                                      value={
                                        this.state.quantity &&
                                          this.state.unitPrice
                                          ? (this.state.quantity * this.state.unitPrice) + (this.state.quantity * this.state.tax)
                                          : ""
                                      }
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorNet ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorNet}
                                    </span>
                                  ) : null}
                                </Col>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "9px" }}>
                                      Requested Patient Share*
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="requestedPatientShare"
                                      // required
                                      readOnly
                                      value={
                                        this.state.quantity ?
                                          this.state.patientShare && this.state.patientShare === 0 ? this.state.patientShare :
                                            this.state.quantity * this.state.patientShare

                                          : ""
                                      }
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorRequestedpatientShare ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorRequestedpatientShare}
                                    </span>
                                  ) : null}
                                </Col>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Label style={{ fontSize: "10px" }}>
                                      Payer Patient Share *
                                    </Form.Label>
                                    <Form.Control
                                      type="number"
                                      name="payerPatientShare"
                                      // required
                                      readOnly
                                      value={
                                        this.state.quantity ?
                                          (this.state.quantity * this.state.unitPrice) +
                                          (this.state.quantity * this.state.tax) - (this.state.quantity * this.state.patientShare)
                                          : ""
                                      }
                                      onChange={
                                        this.HandleProcedureInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                  {this.state.errorPayerpatientShare ? (
                                    <span
                                      style={{
                                        color: "red",
                                        fontSize: "10px",
                                        marginBottom: "0",
                                      }}
                                    >
                                      {this.state.errorPayerpatientShare}
                                    </span>
                                  ) : null}
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        </Row>
                        <hr />
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Start Date\Time
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="servicedDate"
                                onChange={this.HandleProcedureInputTextChange}
                                // required
                                value={this.state.servicedDate}
                              />
                            </Form.Group>
                          </Col>
                          <Col>
                            <div>
                              <Form.Label style={{ fontSize: "13px" }}>
                                Related Supporting Info
                              </Form.Label>
                              <Multiselect
                                placeholder="Supporting Informatiom"
                                selectedValues={this.state.selectedOptions}
                                options={this.state.vitalSignSelectArray}
                                onSelect={this.onSelectCategory}
                                onRemove={this.onRemoveCategory}
                                displayValue="view"
                                key={this.state.keyinfo}
                              />
                            </div>
                          </Col>
                          <Col>
                            <div>
                              <Form.Label style={{ fontSize: "13px" }}>
                                Related Diagnosis
                              </Form.Label>
                              <Multiselect
                                placeholder="Diagnosis"
                                options={this.state.allDiagnosisSelect}
                                onSelect={this.onSelectDiagnosis}
                                onRemove={this.onRemoveDiagnosis}
                                displayValue="view"
                                key={this.state.keyDiag}
                                selectedValues={
                                  this.state.selectedOptionsDiagnosis
                                }
                              />
                            </div>
                          </Col>
                          <Col>
                            <div>
                              <Form.Label style={{ fontSize: "13px" }}>
                                Care Teams
                              </Form.Label>
                              <Multiselect
                                placeholder="CareTeams"
                                options={this.state.allCareTeamSelect}
                                onSelect={this.onSelectCareTeams}
                                onRemove={this.onRemoveCareTeams}
                                displayValue="view"
                                key={this.state.keyCare}
                                selectedValues={
                                  this.state.selectOptionsCareTeam
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <FormControl sx={{ mb: 3, width: "100%" }}>
                              <Form.Label style={{ fontSize: "13px" }}>
                                None Standard Code
                              </Form.Label>
                              <Autocomplete
                                sx={{
                                  ".css-1x51dt5-MuiInputBase-input-MuiInput-input":
                                  {
                                    marginTop: "2px",
                                    border: "1px solid #80808080",
                                    borderRadius: "5px",
                                    paddingTop: "4px",
                                  },
                                }}
                                suggestions={this.state.nonStandardCodeOptions}
                                onChangeSetCode={
                                  this.handleNonStandardCodeSelect
                                }
                                value={this.state.nonstandardCode} //mmmmmmmmmmmmmm
                                flag={this.state.noneStandardAutoCompleteValue}
                                name="nonstandardCode"
                              />
                            </FormControl>
                            <div>
                              <Button
                                variant="primary"
                                type="submit"
                                onClick={(e) => this.handleAddProcedure(e)}
                                style={{
                                  width: "45%",
                                  backgroundColor: "rgb(78 75 75)",
                                  border: "1px solid rgb(78 75 75)",
                                  marginRight: "5px",
                                }}
                              >
                                {this.state.updateProcedure ? (
                                  <BookmarkBorderIcon
                                    style={{ fontSize: "19px" }}
                                  />
                                ) : (
                                  <AddIcon style={{ fontSize: "19px" }} />
                                )}
                              </Button>
                              <Button
                                variant="primary"
                                type="submit"
                                onClick={(e) => this.handleRestItemsValue(e)}
                                style={{
                                  width: "45%",
                                  backgroundColor: "rgb(78 75 75)",
                                  border: "1px solid rgb(78 75 75)",
                                }}
                              >
                                Reset
                              </Button>
                            </div>
                            {this.state.proceduresError ? (
                              <span
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  marginBottom: "0",
                                }}
                              >
                                {this.state.proceduresError}
                              </span>
                            ) : null}
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                None Standard Display
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="standardDisplay"
                                // required
                                onChange={this.HandleProcedureInputTextChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col style={{ position: "relative" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                position: "absolute",
                                top: "32px",
                                left: "8%",
                              }}
                            >
                              <Button
                                disabled={
                                  this.state.productOrService.code
                                    ? false
                                    : true
                                }
                                variant="primary"
                                type="submit"
                                onClick={(e) => this.getPriceListInfo(e)}
                                style={{
                                  width: "54%",
                                  backgroundColor: "rgb(78 75 75)",
                                  border: "1px solid rgb(78 75 75)",
                                  fontSize: "10px",
                                  height: "37px",
                                  transition:
                                    "background-color 0.4s, color 0.4s",
                                }}
                              >
                                {this.state.getPriceListLoading
                                  ? "Loading ... "
                                  : "Get Price List Info"}
                              </Button>
                              <div
                                style={{
                                  padding: "10px",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  name="isPackage"
                                  onChange={(e) => this.handleCheckBoxChange(e)}
                                />
                                <span
                                  style={{
                                    fontSize: "13px",
                                    margin: "3px",
                                    display: "inline-block",
                                  }}
                                >
                                  package
                                </span>
                              </div>
                            </div>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Body Site
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleProcedureInputTextChange}
                                // required
                                name="bodySite"
                              >
                                <option value="0">Please Select</option>
                                {/* <option value="NI">NI</option> */}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Body Sub Site
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleProcedureInputTextChange}
                                // required
                                name="bodySubSite"
                              >
                                <option value="0">Please Select</option>
                                {/* <option value="NI">NI</option> */}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                        {this.state.addProceduretotable &&
                          procedures &&
                          procedures.length > 0 ? (
                          <div style={{ marginTop: "10px" }}>
                            <TableContainer
                              component={Paper}
                              style={{
                                margin: "0 auto 10px",
                                width: "100%",
                              }}
                            >
                              <Table aria-label="simple table">
                                <TableHead
                                  style={{ backgroundColor: "#fafafa" }}
                                >
                                  <TableRow style={{ textAlign: "center" }}>
                                    <TableCell align="center">Code</TableCell>
                                    <TableCell align="center">Type</TableCell>
                                    <TableCell align="center">
                                      Description
                                    </TableCell>
                                    <TableCell align="center">Price</TableCell>
                                    <TableCell align="center">Tax</TableCell>
                                    <TableCell align="center">
                                      Patient Share
                                    </TableCell>
                                    <TableCell align="center">
                                      Related Care Teams
                                    </TableCell>
                                    <TableCell align="center">
                                      Related Diagnosis
                                    </TableCell>
                                    <TableCell align="center">
                                      Related Supporting Info
                                    </TableCell>
                                    <TableCell align="center">Action</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>{procedureRows}</TableBody>
                              </Table>
                            </TableContainer>
                          </div>
                        ) : null}
                      </Container>
                    </FormControl>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <Accordion
                defaultActiveKey="0"
                style={{
                  width: "100%",
                }}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>Encounter</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <FormControl style={{ width: "100%" }}>
                      <Container>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Encounter Class *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleEncounterInputTextChange}
                                required
                                name="class"
                                value={this.state.encounterClassValue}
                              >
                                <option value="0">
                                  select Encounter Class
                                </option>
                                <option value="EMER-emergency">
                                  Emergency
                                </option>
                                <option value="IMP-inpatient encounter">
                                  inpatient encounter
                                </option>
                                <option value="AMB-ambulatory">
                                  ambulatory
                                </option>
                                <option value=" OBSENC-observation encounter">
                                  observation encounter
                                </option>
                                <option value="VR-virtual">virtual</option>
                                <option value="HH-home health">
                                  home health
                                </option>
                              </Form.Select>
                              {this.state.errorClassValue ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorClassValue}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Encounter Service Type
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleEncounterInputTextChange}
                                required
                                name="type"
                              >
                                <option value="0">
                                  select Encounter Service Type
                                </option>
                                <option value="finished">Finished</option>
                                <option value="planned">Planned</option>
                                <option value="arrived">Arrived</option>
                                <option value="triaged">Triaged</option>
                                <option value="in-progress">In-Progress</option>
                                <option value="onleave">Onleave</option>
                                <option value="cancelled">Cancelled</option>
                              </Form.Select>
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Encounter Priority
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleEncounterInputTextChange}
                                required
                                name="encounterPriority"
                              >
                                <option value="0">
                                  select Encounter Priority
                                </option>
                                <option value="S">stat</option>
                                <option value="A">ASAP</option>
                                <option value="UR">urgent</option>
                                <option value="CR">callback results</option>
                                <option value="CS">
                                  callback for scheduling
                                </option>
                                <option value="CSP">
                                  callback placer for scheduling
                                </option>
                                <option value="CSR">
                                  contact recipient for scheduling
                                </option>
                                <option value="EM">emergency</option>
                                <option value="PRN">as needed</option>
                                <option value="R">routine</option>
                                <option value="RR">rush reporting</option>
                                <option value="T">timing critical</option>
                                <option value="UD">use as directed</option>
                                {/* <option value="NI">NI</option> */}
                              </Form.Select>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Form.Group className="mb-3">
                              <Form.Label style={{ fontSize: "13px" }}>
                                Encounter Status *
                              </Form.Label>
                              <Form.Select
                                onChange={this.HandleEncounterInputTextChange}
                                required
                                name="status"
                                value={this.state.enconterStatusValue}
                              >
                                <option value="0">
                                  select Encounter Status
                                </option>
                                <option value="planned">Planned</option>
                                <option value="arrived">Arrived</option>
                                <option value="triaged">Triaged</option>
                                <option value="in-progress">In Progress</option>
                                <option value="onleave">On Leave</option>
                                <option value="finished">Finished</option>
                                <option value="cancelled">Cancelled</option>
                              </Form.Select>
                              {this.state.errorStatusValue ? (
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "12px",
                                    marginBottom: "0",
                                  }}
                                >
                                  {this.state.errorStatusValue}
                                </span>
                              ) : null}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Label style={{ fontSize: "13px" }}>
                              Encounter Period
                            </Form.Label>
                            <Row>
                              <div style={{ width: "46%" }}>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      type="date"
                                      name="start"
                                      value={this.state.start}
                                      onChange={
                                        this.HandleEncounterInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                </Col>
                              </div>
                              <div style={{ width: "8%", padding: "0" }}>
                                <Col>
                                  <EastIcon />
                                </Col>
                              </div>
                              <div style={{ width: "46%" }}>
                                <Col>
                                  <Form.Group className="mb-3">
                                    <Form.Control
                                      type="date"
                                      name="end"
                                      value={this.state.end}
                                      onChange={
                                        this.HandleEncounterInputTextChange
                                      }
                                    />
                                  </Form.Group>
                                </Col>
                              </div>
                            </Row>
                          </Col>
                          <Col>
                            <Form.Group
                              className="mb-3"
                              style={{ visibility: "hidden" }}
                            >
                              <Form.Label style={{ fontSize: "13px" }}>
                                Encounter Identifier
                              </Form.Label>

                              <Form.Control
                                type="text"
                                name="identifier"
                                onChange={this.HandleEncounterInputTextChange}
                                // required
                                placeholder="Enter Encounter Identifier"
                                value={this.state.identifier}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                        <hr />
                        <div>
                          <Button
                            variant="primary"
                            style={{
                              width: "25%",
                              marginTop: "32px",
                              backgroundColor: "rgb(78 75 75)",
                              border: "1px solid rgb(78 75 75)",
                            }}
                            onClick={this.toggleRowVisibility}
                          >
                            Patient is Transferred
                          </Button>
                          {this.state.showRow && (
                            <Row>
                              <Col>
                                <Form.Group className="mb-3">
                                  <Form.Label style={{ fontSize: "13px" }}>
                                    Origin
                                  </Form.Label>
                                  <Form.Select
                                    onChange={
                                      this.HandleEncounterInputTextChange
                                    }
                                    required
                                    name="origin"
                                  >
                                    <option value="0">select Origin</option>
                                    {/* <option value="NI">NI</option> */}
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                              <Col>
                                <Form.Group className="mb-3">
                                  <Form.Label style={{ fontSize: "13px" }}>
                                    Admit Source
                                  </Form.Label>
                                  <Form.Select
                                    onChange={
                                      this.HandleEncounterInputTextChange
                                    }
                                    required
                                    name="admitSource"
                                  >
                                    <option value="0">
                                      select Admit Source
                                    </option>
                                    {/* <option value="NI">NI</option> */}
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                              <Col>
                                <Form.Group className="mb-3">
                                  <Form.Label style={{ fontSize: "13px" }}>
                                    ReAdmission
                                  </Form.Label>
                                  <Form.Select
                                    onChange={
                                      this.HandleEncounterInputTextChange
                                    }
                                    required
                                    name="reAdmission"
                                  >
                                    <option value="0">
                                      select ReAdmission
                                    </option>
                                    {/* <option value="NI">NI</option> */}
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                              <Col>
                                <Form.Group className="mb-3">
                                  <Form.Label style={{ fontSize: "13px" }}>
                                    Discharge Disposition
                                  </Form.Label>
                                  <Form.Select
                                    onChange={
                                      this.HandleEncounterInputTextChange
                                    }
                                    required
                                    name="dischargeDisposition"
                                  >
                                    <option value="0">
                                      select Discharge Disposition
                                    </option>
                                    {/* <option value="NI">NI</option> */}
                                  </Form.Select>
                                </Form.Group>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </Container>
                    </FormControl>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <div style={{ marginTop: "15px" }}>
                <Button
                  variant="primary"
                  type="submit"
                  onClick={(e) => this.handleAuthorization(e)}
                  style={{
                    width: "25%",
                    marginTop: "32px",
                    backgroundColor: "rgb(78 75 75)",
                    border: "1px solid rgb(78 75 75)",
                  }}
                >
                  Authorization Request
                </Button>
              </div>
              {this.state.errorValidForm ? (
                <div
                  style={{
                    color: "red",
                    marginTop: "10px",
                    textAlign: "center",
                  }}
                >
                  {this.state.errorValidForm}
                </div>
              ) : this.state.requestSent && !this.state.response ? (
                <div style={{ textAlign: "center", marginTop: "10px" }}>
                  <Spinner animation="border" variant="success" />
                </div>
              ) : this.state.response && this.state.Autherror ? (
                <h5 style={{ color: "red", textAlign: "center" }}>
                  {this.state.Autherror}
                </h5>
              ) : null}
              <div>
                {this.state.outcome ? (
                  <>
                    {this.state.HL7Request ? (
                      <>
                        <div style={{ marginTop: "15px", textAlign: "right" }}>
                          <Button
                            variant="primary"
                            type="submit"
                            onClick={() => this.downloadJsonFile()}
                            style={{
                              width: "25%",
                              marginTop: "32px",
                              marginLeft: "20px",
                              backgroundColor: "blue",
                              border: "1px solid blue",
                              fontSize: "11px"
                            }}
                          >
                            Download JSON Request <ArrowDownwardIcon />
                          </Button>
                        </div>
                      </>
                    ) : null}
                    <hr />
                    <h6>Claim ID : {this.state.authID}</h6>
                    <h6>Encounter ID : {this.state.encounterID}</h6>
                    <h4 style={{ textAlign: "center" }}>
                      Authorization Response
                    </h4>
                    {itemRows && itemRows.length > 0 ? (
                      <>
                        <h4 style={{ textAlign: "center" }}>Items</h4>
                        <TableContainer
                          component={Paper}
                          style={{
                            margin: "10px auto",
                            width: "100%",
                          }}
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">
                                  Item Sequence
                                </TableCell>
                                <TableCell align="center">Outcome</TableCell>
                                <TableCell align="center">
                                  Adjudications
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{itemRows}</TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : null}
                    {totalRows && totalRows.length > 0 ? (
                      <>
                        <h4 style={{ textAlign: "center" }}>Total</h4>
                        <TableContainer
                          component={Paper}
                          style={{
                            margin: "10px auto",
                            width: "100%",
                          }}
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">Category</TableCell>
                                <TableCell align="center">Amount</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{totalRows}</TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : null}
                    {this.state.outcome == "queued" ? (
                      <TableContainer
                        component={Paper}
                        style={{
                          margin: "10px auto",
                          width: "100%",
                        }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Outcome</TableCell>
                              <TableCell align="center">
                                Authorization Request Identifier
                              </TableCell>
                              <TableCell align="center">
                                Authorization Response Identifier
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableCell align="center">
                              {this.state.outcome}
                            </TableCell>
                            <TableCell align="center">
                              {this.state.authorizationRequestIdentifier}
                            </TableCell>
                            <TableCell align="center">
                              {this.state.authorizationResponseIdentifier}
                            </TableCell>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : null}
                    {this.state.outcome == "error" ? (
                      <>
                        <Typography
                          id="modal-modal-title"
                          variant="h6"
                          component="h2"
                          style={{ textAlign: "center" }}
                        >
                          Errors
                        </Typography>
                        <TableContainer
                          component={Paper}
                          style={{
                            margin: "10px auto",
                            width: "100%",
                          }}
                        >
                          <Table aria-label="simple table">
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell align="center">Code</TableCell>
                                <TableCell align="center">Display</TableCell>
                                <TableCell align="center">Extension</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>{errorRows}</TableBody>
                          </Table>
                        </TableContainer>
                      </>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default PreAuthorization;
